module.exports = __webpack_public_path__ + "img/92.f272fce6.jpg";